import {
  AccountPage,
  CriteriaPage,
  LandingPage,
  LoginPage,
  MedicalBenefitSearchPage,
  MedicalClaimsPage,
  MedicalClaimsSearchPage,
  MedicalMemberLookupPage,
  NewNetworkPage,
  NotificationsPage,
  PACasePage,
  PACreateDraftSuccessPage,
  PACaseDraftAccessPage,
  PACreatePage,
  PASearchPage,
  PharmacyComms,
  PharmacyCommsFileSent,
  ProviderDocumentsPage,
  ViewNetworkPage,
} from "@/pages";
import { URL, CLIENT_URL } from "@/constants/urls";
import { RouteProps } from "./types";

const createRoutes = (urls: typeof URL): Array<RouteProps> => [
  {
    path: urls.HOME,
    Component: LandingPage,
  },
  {
    path: urls.ACCOUNT,
    Component: AccountPage,
  },
  {
    path: urls.ACCOUNT_NETWORK_CREATE,
    Component: NewNetworkPage,
  },
  {
    path: urls.ACCOUNT_NETWORK_VIEW,
    Component: ViewNetworkPage,
  },
  {
    path: urls.LOGIN,
    Component: LoginPage,
  },
  {
    path: urls.MEDICAL_CLAIMS,
    Component: MedicalClaimsSearchPage,
  },
    {
    path: urls.MEDICAL_CLAIM_LIST,
    Component: MedicalClaimsPage,
  },
  {
    path: urls.NOTIFICATIONS,
    Component: NotificationsPage,
  },
  {
    path: urls.PA_SEARCH,
    Component: PASearchPage,
  },
  {
    path: urls.PA_CREATE,
    Component: PACreatePage,
  },
  {
    path: urls.PA_CASE,
    Component: PACasePage,
  },
  {
    path: urls.PA_CREATE_CASE_DRAFT_SUCCESS,
    Component: PACreateDraftSuccessPage,
  },
  {
    path: urls.PA_CASE_DRAFT_ACCESS,
    Component: PACaseDraftAccessPage,
  },
  {
    path: urls.PHARMACY,
    Component: PharmacyComms,
  },
  {
    path: urls.PHARMACY_SUBMIT,
    Component: PharmacyCommsFileSent,
  },
  {
    path: urls.PATIENT_LOOKUP,
    Component: MedicalMemberLookupPage,
  },
  {
    path: urls.PATIENT_COVERAGE_SEARCH,
    Component: MedicalBenefitSearchPage,
  },
  {
    path: urls.PROVIDER_DOCUMENTS,
    Component: ProviderDocumentsPage,
  },
  {
    path: urls.CRITERIA,
    Component: CriteriaPage,
  },
];

export const hcpRoutes: Array<RouteProps> = [
  ...createRoutes(URL),
  ...createRoutes(CLIENT_URL),
];
